import { EventEditScope, EVENT_EDIT_SCOPE_DISPLAY } from "@mimber/schema"

export const SCOPE_OPTIONS = (
  Object.entries(EVENT_EDIT_SCOPE_DISPLAY) as [
    EventEditScope,
    { label: string; description: string },
  ][]
).map(([value, { label, description }]) => ({ value, label, description }))
